export type VehicleType = 'CAR' | 'TAXI' | 'VAN' | 'CARAVAN' | 'MOTORBIKE' | 'PLG'

export const mapToVehicleType = (vehicleType?: string): VehicleType => {
  if (!vehicleType) return 'CAR'
  switch (vehicleType.toLowerCase()) {
    case 'car':
    case 'vehicle_type_car':
      return 'CAR'
    case 'taxi':
      return 'TAXI'
    case 'van':
    case 'vehicle_type_van':
      return 'VAN'
    case 'caravan':
    case 'vehicle_type_caravan':
      return 'CARAVAN'
    case 'motorbike':
    case 'vehicle_type_motorbike':
      return 'MOTORBIKE'
    default:
      return 'CAR'
  }
}
